export default __webpack_public_path__ + "static/media/telegram.8bd8c078.svg";